'use client'

import { ImageNotFound } from 'fukku/Image'
import { useArticleImage } from 'my-purchases/hooks/useArticleImage/useArticleImage'
import { useState } from 'react'
import SmartCropImage from 'utils/image/components/SmartCropImage/SmartCropImage'
import { cardImageSizes } from 'utils/image/constants/cardImageSizes'
import { generateImagesSizes } from 'utils/image/generateImagesSizes/generateImagesSizes'

import styles from './CardImage.module.scss'

interface CardImageProps {
	readonly src: string
	readonly alt: string
	readonly noImageText?: string
	readonly articleImageId?: string
	readonly colorId?: string
	readonly onClick?: () => void
}

export function CardImage({
	src,
	alt,
	noImageText,
	articleImageId,
	colorId,
	onClick,
}: CardImageProps) {
	const [imageError, setImageError] = useState(false)

	const { imageToShow } =
		useArticleImage({
			articleId: articleImageId ?? '',
			colorId,
		}) ?? {}

	const cardImageValue = imageToShow ?? src

	const onError = () => {
		setImageError(true)
	}

	return imageError || !cardImageValue ? (
		<div className={styles.noImage}>
			<ImageNotFound className={styles.notFound} />
			{noImageText && <p className={styles.notFoundText}>{noImageText}</p>}
		</div>
	) : (
		<SmartCropImage
			src={cardImageValue}
			alt={alt}
			onError={onError}
			className={styles.image}
			draggable={false}
			sizes={generateImagesSizes(cardImageSizes)}
			{...(onClick && { onClick })}
		/>
	)
}
